export default __webpack_public_path__ + "static/media/welcome.5947a3b4.svg";